import { Navigate } from 'react-router';

export default function NotFoundView() {
  return <Navigate replace to="/" />;
}
